(function () {
  function moveSlider(group, btn) {
    var slider = group.querySelector('.pill-slider');
    if (!slider || !btn) return;
    if (btn.offsetWidth === 0) return;
    slider.style.width = btn.offsetWidth + 'px';
    slider.style.transform = 'translateX(' + (btn.offsetLeft - 4) + 'px)';
  }

  function init(root) {
    var standard = root.getAttribute('data-date-standard') || '';
    var express = root.getAttribute('data-date-express') || '';
    if (!standard && !express) return;

    var nameStd = root.getAttribute('data-name-standard') || 'Standard Shipping';
    var nameExp = root.getAttribute('data-name-express') || 'Express Shipping';
    var feeStd = root.getAttribute('data-fee-standard') || '';
    var feeExp = root.getAttribute('data-fee-express') || '';

    var groups = root.querySelectorAll('.pill-toggle-group');

    groups.forEach(function (group) {
      var pills = group.querySelectorAll('.pill-btn');

      moveSlider(group, group.querySelector('.pill-btn.active') || pills[0]);

      pills.forEach(function (btn) {
        btn.addEventListener('click', function () {
          pills.forEach(function (p) { p.classList.remove('active'); });
          btn.classList.add('active');
          moveSlider(group, btn);

          var is_express = btn.getAttribute('data-value') === 'express';
          var label = (is_express ? nameExp : nameStd) + ':';
          var date = is_express ? express : standard;
          var fee = is_express ? feeExp : feeStd;

          root.querySelectorAll('.ship-title-display').forEach(function (el) {
            el.textContent = label;
          });
          root.querySelectorAll('.timeline-delivered').forEach(function (el) {
            el.textContent = date;
          });
          root.querySelectorAll('.timeline-fee').forEach(function (el) {
            var i = fee.lastIndexOf(' ');
            el.textContent = fee.indexOf('$') >= 0 && i > 0 ? fee.slice(i + 1) : fee;
          });
        });
      });
    });

    function reposition() {
      groups.forEach(function (group) {
        moveSlider(group, group.querySelector('.pill-btn.active'));
      });
    }

    window.addEventListener('resize', reposition);

    var details = root.closest('details');
    if (details) details.addEventListener('toggle', reposition);

    var panel = root.querySelector('.modal-shipping .wt-grid.fulfillment');
    if (panel && window.MutationObserver) {
      new MutationObserver(reposition).observe(panel, {
        attributes: true, attributeFilter: ['class']
      });
    }
  }

  function boot() {
    document
      .querySelectorAll('.box-shiping-cutoff, .product__accordion .shipping')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
